import PartnerController from './Controller/PartnerController';

$(document).ready(function () {
	new PartnerController();
});